// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"1130ad638da92d4a","491":"0e4bfb9e658bba34","963":"5966e1659525ce1e"}[chunkId] + ".js";
};